import {API_PATH, BASE_PATH} from "./global_settings.js"

let currentUser = null
let menuStructure = []

export async function initializeMenu()
{
    const token = localStorage.getItem("token")
    if (!token)
    {
        hideMenu()
        return false
    }

    try
    {
        const userResponse = await fetch(`${API_PATH}/me`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })

        if (!userResponse.ok)
        {
            if (userResponse.status === 401 || userResponse.status === 403)
            {
                localStorage.removeItem("token")
            }
            hideMenu()
            return false
        }

        currentUser = await userResponse.json()

        const menuResponse = await fetch(`${API_PATH}/menu/structure`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        if (menuResponse.ok)
        {
            menuStructure = await menuResponse.json()
        }

        // Инициализируем тему перед показом меню
        initializeTheme()
        showMenu()
        return true
    }
    catch (error)
    {
        console.error("Ошибка инициализации меню:", error)

        localStorage.removeItem("token")
        hideMenu()
        return false
    }
}

function initializeTheme()
{
    const savedTheme = localStorage.getItem("theme")
    const isDark = savedTheme === "dark"

    if (isDark)
    {
        document.documentElement.classList.add("dark")
        document.body.classList.add("dark")
    }
    else
    {
        document.documentElement.classList.remove("dark")
        document.body.classList.remove("dark")
    }
}

function toggleTheme()
{
    const isDark = document.body.classList.contains("dark")

    if (isDark)
    {
        document.documentElement.classList.remove("dark")
        document.body.classList.remove("dark")
        localStorage.setItem("theme", "light")
    }
    else
    {
        document.documentElement.classList.add("dark")
        document.body.classList.add("dark")
        localStorage.setItem("theme", "dark")
    }

    updateThemeToggle()

    // Обновляем тему Three.js если функция доступна
    if (typeof window.updateThreeJSTheme === "function")
    {
        window.updateThreeJSTheme()
    }
}

function updateThemeToggle()
{
    const themeToggle = document.getElementById("themeToggle")
    const themeIcon = document.getElementById("themeIcon")

    if (themeToggle && themeIcon)
    {
        const isDark = document.body.classList.contains("dark")
        themeToggle.classList.toggle("dark", isDark)
        themeIcon.textContent = isDark ? "🌙" : "☀️"
    }
}

function hideMenu()
{
    const existingMenu = document.getElementById("globalMenu")
    if (existingMenu)
    {
        existingMenu.remove()
    }
}

function showMenu()
{
    hideMenu() // Удаляем существующее меню

    const currentPath = window.location.pathname
    const isAdminPage = currentPath.includes("admin.html")

    const menuHTML = `
        <header id="globalMenu" class="menu-header">
            <div class="menu-container">
                <div class="menu-content">
                    <!-- Логотип и навигация -->
                    <div class="menu-left">
                        <a href="index.html" class="menu-logo">🪑 CAD</a>
                        <nav class="menu-nav" id="modulesMenu">
                            ${renderMenuItems()}
                        </nav>
                        <!-- Мобильное меню -->
                        <div class="menu-mobile-toggle">
                            <button id="mobileMenuToggle" class="mobile-menu-button">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                    
                    <!-- Пользователь и действия -->
                    <div class="menu-right">
                        <!-- Переключатель темы -->
                        <button id="themeToggle" class="theme-toggle" onclick="globalToggleTheme()" title="Переключить тему">
                            <span id="themeIcon" class="theme-icon">☀️</span>
                        </button>
                        
                        <span class="user-email">${currentUser.email}</span>
                        ${!isAdminPage && currentUser.is_admin ? `<a href="admin.html" class="menu-button admin-button">Панель администратора</a>` : ""}
                        <button onclick="globalLogout()" class="menu-button logout-button">Выйти</button>
                    </div>
                </div>
                
                <!-- Мобильная навигация -->
                <div id="mobileMenu" class="mobile-menu">
                    <div class="mobile-menu-content">
                        ${renderMobileMenuItems()}
                    </div>
                </div>
            </div>
        </header>
    `

    // Вставляем меню в начало body
    document.body.insertAdjacentHTML("afterbegin", menuHTML)

    // Инициализируем обработчики
    initializeMenuHandlers()

    // Обновляем переключатель темы
    updateThemeToggle()
}

function renderMenuItems()
{
    return menuStructure.map(item =>
    {
        if (item.children && item.children.length > 0)
        {
            return `
                <div class="menu-dropdown">
                    <button class="menu-dropdown-toggle">
                        ${item.title}
                        <svg class="dropdown-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                    </button>
                    <div class="menu-dropdown-content">
                        <div class="dropdown-items">
                            ${item.children.map(child => `
                                <a href="${child.url}" class="dropdown-item">
                                    ${child.title}
                                </a>
                            `).join("")}
                        </div>
                    </div>
                </div>
            `
        }
        else
        {
            return `
                <a href="${item.url}" class="menu-item">
                    ${item.title}
                </a>
            `
        }
    }).join("")
}

function renderMobileMenuItems()
{
    return menuStructure.map(item =>
    {
        if (item.children && item.children.length > 0)
        {
            return `
                <div class="mobile-menu-item">
                    <button class="mobile-menu-toggle">
                        ${item.title}
                        <svg class="mobile-toggle-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                    </button>
                    <div class="mobile-submenu">
                        ${item.children.map(child => `
                            <a href="${child.url}" class="mobile-submenu-item">
                                ${child.title}
                            </a>
                        `).join("")}
                    </div>
                </div>
            `
        }
        else
        {
            return `
                <a href="${item.url}" class="mobile-menu-link">
                    ${item.title}
                </a>
            `
        }
    }).join("")
}

function initializeMenuHandlers()
{
    // Мобильное меню
    const mobileMenuToggle = document.getElementById("mobileMenuToggle")
    const mobileMenu = document.getElementById("mobileMenu")

    if (mobileMenuToggle && mobileMenu)
    {
        mobileMenuToggle.addEventListener("click", () =>
        {
            mobileMenu.classList.toggle("open")
        })
    }

    // Подменю в мобильной версии
    document.querySelectorAll(".mobile-menu-toggle").forEach(toggle =>
    {
        toggle.addEventListener("click", () =>
        {
            const submenu = toggle.nextElementSibling
            const icon = toggle.querySelector(".mobile-toggle-icon")

            submenu.classList.toggle("open")
            icon.classList.toggle("rotated")
        })
    })
}

// Глобальные функции
window.globalLogout = function ()
{
    localStorage.removeItem("token")
    window.location.href = `${BASE_PATH}/`
}

window.globalToggleTheme = function ()
{
    toggleTheme()
}

// Функция для проверки авторизации
export async function checkAuthentication()
{
    return await initializeMenu()
}

export {currentUser}